import { ValidationError } from '@multiplier/lib-shared-errors';
import { DateTime } from 'luxon';
import { z } from 'zod';
export const DateRangeSchema = z.object({
    fromDate: z.iso.datetime().describe('Date range start date in ISO format'),
    toDate: z.iso.datetime().describe('Date range end date in ISO format'),
});
/**
 * Creates a DateRange from Date objects
 */
export function createDateRange(fromDate, toDate) {
    if (Number.isNaN(fromDate.getTime())) {
        throw new ValidationError('fromDate must be a valid date', 'fromDate');
    }
    if (Number.isNaN(toDate.getTime())) {
        throw new ValidationError('toDate must be a valid date', 'toDate');
    }
    if (fromDate > toDate) {
        throw new ValidationError('fromDate must be before or equal to toDate', 'fromDate');
    }
    return {
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
    };
}
/**
 * Creates a DateRange from date strings
 */
export function dateRangeFromStrings(fromDate, toDate) {
    const fromDateTime = DateTime.fromISO(fromDate, { zone: 'utc' });
    const toDateTime = DateTime.fromISO(toDate, { zone: 'utc' });
    if (!fromDateTime.isValid) {
        throw new ValidationError(`Invalid fromDate: ${fromDateTime.invalidReason}`, 'fromDate');
    }
    if (!toDateTime.isValid) {
        throw new ValidationError(`Invalid toDate: ${toDateTime.invalidReason}`, 'toDate');
    }
    return createDateRange(fromDateTime.toJSDate(), toDateTime.toJSDate());
}
/**
 * Gets the number of days in a date range
 */
export function getDayCount(range) {
    const from = new Date(range.fromDate);
    const to = new Date(range.toDate);
    const diffTime = to.getTime() - from.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}
/**
 * Checks if a date falls within a range
 */
export function dateRangeContains(range, date) {
    const from = new Date(range.fromDate);
    const to = new Date(range.toDate);
    return date >= from && date <= to;
}
/**
 * Gets Date objects from a DateRange
 */
export function getDateRangeBounds(range) {
    return {
        fromDate: new Date(range.fromDate),
        toDate: new Date(range.toDate),
    };
}
//# sourceMappingURL=DateRange.js.map